import { AUTH_LOADING_LABELS } from 'common/constants/auth';

export const OTP_LOADING_LABEL = AUTH_LOADING_LABELS.twoFactor;
export const OTP_COMPLETING_LABEL = AUTH_LOADING_LABELS.nextStep;
export const UNKNOWN_OTP_ERROR_MESSAGE = 'Unknown error';

export const VERIFY_STEP = 'verify';
export const IDLE_STEP = 'idle';
export const SETUP_STEP = 'setup';
export const RESULT_STEP = 'result';
export const REQUEST_STAGE = 'request';
